import React, { useEffect, useState } from "react";
import "./add-item-modal.css";
import "./add-employee-modal.css";
import { showToast } from "../toasts/ToastNotification";
import { ClipLoader } from "react-spinners";
import { createNewEmployee } from "../../api/user.api";

const AddEmployeeModal = ({ isOpen, onClose, title, setEmployees }) => {
    const [loading, setLoading] = useState(false);
    const [selected, setSelected] = useState("editor");

    const handleAddNewEmployee = async () => {
        setLoading(true);

        try {
            let res = await createNewEmployee(selected);

            if (res.success) {
                showToast("Thêm mới thành công", "success");
                setEmployees((prev) => ([
                    ...prev,
                    res.data.newEmployee
                ]));
                onClose();
            }
        } catch (error) {
            showToast(error.message, "error");
        } finally {
            setLoading(false);
        }
    }

    if (!isOpen) return null;

    return (
        <div className="add-item-modal-overlay">
            <div className="add-item-modal-content">
                <h2 className="add-item-modal-title">{title}</h2>
                <p className="modal-message">Tên đăng nhập, email sẽ được tạo tự động và mật khẩu mặc định là "admin123"</p>
                <select className="admin-type-select" onChange={(e) => setSelected(e.target.value)}>
                    <option value={"editor"} label="Editor"></option>
                    <option value={"supporter"} label="Supporter"></option>
                </select>
                <div className="add-item-modal-buttons">
                    <button disabled={loading} className="cancel-btn" onClick={onClose}>Hủy</button>
                    <button disabled={loading} className="confirm-btn update-button" onClick={handleAddNewEmployee}>{loading ? <ClipLoader size={20} color="#fff" /> : "Thêm"}</button>
                </div>
            </div>
        </div>
    );
};

export default AddEmployeeModal;